module.exports = __webpack_public_path__ + "img/30-green.664f7861.svg";